/** @format */
import {FunnelGoalStatFromQuery} from '../../models/api';

/**
 * Аккумулирует все данные воронок, учитывая периодичность
 * @param data
 * @param rechartsDates
 */

const mapFunnel = (
  data: ReadonlyArray<FunnelGoalStatFromQuery>,
  rechartsDates: string[],
): ReadonlyArray<FunnelGoalStatFromQuery> => {
  if (data.length === 0 || rechartsDates.length === 0) {
    return [];
  }

  const grouped = new Map<number, FunnelGoalStatFromQuery[]>();

  data.forEach(stat => {
    if (!grouped.has(stat.goalId)) {
      grouped.set(stat.goalId, []);
    }
    grouped.get(stat.goalId)!.push(stat);
  });

  const sortedDiscrete = [...rechartsDates].sort();
  const result: FunnelGoalStatFromQuery[] = [];

  for (const [goalId, list] of grouped) {
    const entries = [...list].sort((a, b) => a.date.localeCompare(b.date));
    let idx = 0;

    sortedDiscrete.forEach(date => {
      let segmentSum = 0;

      // забираем все значения, которые <= текущей дискретной даты
      while (idx < entries.length && entries[idx].date <= date) {
        segmentSum += entries[idx].conversions;
        idx++;
      }

      result.push({
        __typename: 'YalperFunnelGoalStat',
        goalId,
        date,
        conversions: segmentSum,
      });
    });
  }

  return result;
};

export {mapFunnel};
